import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class ServicoEstadoFiltro {
  private estadoFiltro: any;

  definirEstadoFiltro(estado: any) {
    this.estadoFiltro = estado;
  }

  obterEstadoFiltro() {
    return this.estadoFiltro;
  }
}